
import param from '~/utils/url/param'
export default {
  name: 'LayoutMenu',
  computed: {
    site() {
      return site
    },
    items() {
      const children = []
      servicos.filter((r) => {
        children.push({
          to: '/servicos/' + r.lnk,
          title: r.name
        })
      })
      return [
        {
          to: './sobre-nos',
          title: 'Sobre nós',
          icon: '<svg viewBox="0 0 24 24" width="1em" height="1em" class="v-icon"><path fill="currentColor" d="M11 9h2V7h-2m1 13c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m-1 15h2v-6h-2v6Z"></path></svg>',
          children: []
        },
        {
          to: './servicos',
          title: 'Serviços',
          icon: '<svg viewBox="0 0 24 24" width="1em" height="1em" class="v-icon"><path fill="currentColor" d="m22.9 21.2l-4.1-4.1c.4-1 .2-2.3-.7-3.1c-.9-.9-2.2-1.1-3.3-.6l1.9 1.9l-1.4 1.4l-2-2c-.5 1.1-.3 2.4.6 3.4c.9.9 2.1 1.1 3.1.7l4.1 4.1c.2.2.5.2.6 0l1-1c.3-.3.3-.6.2-.7M13 20H2v-2c0-2.2 3.6-4 8-4c.5 0 1 0 1.4.1c-.3.6-.4 1.2-.4 1.9c0 1.6.8 3.1 2 4M10 4C7.8 4 6 5.8 6 8s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4"></path></svg>',
          children
        },
        {
          to: './horario',
          title: 'Horário de atendimento',
          icon: '<svg viewBox="0 0 24 24" width="1em" height="1em" class="v-icon"><path fill="currentColor" d="M11 17a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1m0-14v4h2V5.08c3.39.49 6 3.39 6 6.92a7 7 0 0 1-7 7a7 7 0 0 1-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41l-6.8-6.8v.02C4.42 6.45 3 9.05 3 12a9 9 0 0 0 9 9a9 9 0 0 0 9-9a9 9 0 0 0-9-9m6 9a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1M6 12a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1Z"></path></svg>',
          children: []
        },
        {
          to: './localizacao',
          title: 'Nossa localização',
          icon: '<svg viewBox="0 0 24 24" width="1em" height="1em" class="v-icon"><path fill="currentColor" d="M12 11.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7Z"></path></svg>',
          children: []
        }
      ]
    }
  },
  methods: {
    openWhats() {
      return `https://api.whatsapp.com/send${param({
        phone: '55' + site.whatsapp.replace(/[^0-9]+/g, ''),
        text: 'Quero marcar uma consulta pelo whatsapp'
      })}`
    }
  }
}
